module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-03.54285f04.png";